import { render, staticRenderFns } from "./ItemListPremiumMarketCreate.vue?vue&type=template&id=27ca666e&scoped=true"
import script from "./ItemListPremiumMarketCreate.vue?vue&type=script&lang=js"
export * from "./ItemListPremiumMarketCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca666e",
  null
  
)

export default component.exports